import { State } from 'shared/interface';
import { createIsActionLoadingSelector } from 'shared/store/loading.selectors';

const MODULE = 'offers';

const selectBonusesActive = (state: State) => state[MODULE].bonusesActive;

const selectBonusesQueued = (state: State) => state[MODULE].bonusesQueued;

export const selectFreebetsActive = (state: State) => state[MODULE].freebetsActive;

const selectHasActiveOffers = (state: State) => {
	return selectBonusesActive(state).length > 0 || selectFreebetsActive(state).length > 0;
};

const selectHasQueuedOffers = (state: State) => {
	return selectBonusesQueued(state).length > 0;
};

export const selectHasAnyOffers = (state: State) => {
	return selectHasActiveOffers(state) || selectHasQueuedOffers(state);
};

export const selectAreBonusesAndFreebetsLoading = createIsActionLoadingSelector('FETCH_BONUSES_AND_FREEBETS');
